import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  styled,
  Typography,
} from '@material-ui/core'
import { ListItemIconProps } from '@material-ui/core/ListItemIcon'
import React from 'react'
import { Checkbox } from '../../../FormBuilder'
import { PopoveredIcon2 } from '../../../PopoveredIcon/PopoveredIcon'

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: '5px',
  '&.Mui-disabled': {
    color: 'red',
    backgroundColor: '#f5f5f5',
    pointerEvents: 'all'
  },
}));

export default function ToolbarMobileItem({
  icon,
  text,
  disabled,
  color = '#000',
  switchable,
  onClick,
  checked,
  className,
}: IToolbarItemProps & IToolbarItemDispatch) {
  return (
    <StyledMenuItem
      style={{ padding: '5px' }}
      onClick={onClick}
      className={className}
      data-cy={className}
      disabled={disabled}
    >
      <span style={{ width: '33px' }}>
        {icon && (
          <ListItemIcon
            style={{
              color,
              margin: '0px 5px',
              minWidth: '0px',
            }}
          >
            {icon}
          </ListItemIcon>
        )}
        {switchable && (
          <div style={{ marginRight: '5px' }}>
            <Checkbox.Field small={true} value={checked} onClick={onClick} />
          </div>
        )}
      </span>
      <ListItemText
        style={{ padding: '0px 5px 0px 0px' }}
        primary={
          <Typography
            style={{
              color,
              fontWeight: 500,
            }}
          >
            {text}
          </Typography>
        }
      />
      {disabled && <PopoveredIcon2 />}
    </StyledMenuItem>
  )
}

export interface IToolbarItemProps {
  icon?: ListItemIconProps['children']
  text: React.ReactNode
  color?: string
  switchable?: boolean
  disabled?: boolean
  className?: string
  checked?: boolean
}

export interface IToolbarItemDispatch {
  toggle?: (checked?: boolean) => void
  onClick?: () => void
}
